import type {
  SHEET_ACTION_BACK_BUTTON,
  SHEET_ACTION_CLOSE_BUTTON,
  SHEET_ACTION_BACK_DROP,
  SHEET_ACTION_DRAG_DOWN,
  SHEET_ACTION_ESCAPE_KEY,
  SHEET_ACTION_PROGRAMMATICALLY,
  SHEET_ACTION_USER_AGENT,
} from "../event/event.activation";
import { sheetScope } from "../utils/props";

export const stackScope = /*           */ sheetScope.scope("stack");

/**
 *
 *
 *
 *
 *
 */
export type ActivationReason = "open-close" | "content-switch";

/**
 *
 *
 */
export type ActivationAction =
  | typeof SHEET_ACTION_CLOSE_BUTTON
  | typeof SHEET_ACTION_BACK_BUTTON
  | typeof SHEET_ACTION_BACK_DROP
  | typeof SHEET_ACTION_DRAG_DOWN
  | typeof SHEET_ACTION_ESCAPE_KEY
  | typeof SHEET_ACTION_PROGRAMMATICALLY
  | typeof SHEET_ACTION_USER_AGENT;

/**
 *
 *
 *
 *
 */
export const findInstance = (sheetId: string | null | undefined): HTMLOcSheetV1Element | null =>
  sheetId ? document.querySelector<HTMLOcSheetV1Element>(`#${sheetId}`) : null;

/**
 *
 *
 *
 */
export const getInstance = (sheetId: string): HTMLOcSheetV1Element =>
  findInstance(sheetId) ??
  (() => {
    throw new Error(`Sheet instance with id ${sheetId} not found in the DOM.`);
  })();
